import styled, { css } from "styled-components";
import { Table } from "@commonlibs";

export const BaseTable = styled(Table)(
    () => css`
        border-radius: 0;
        border: var(--table-border) !important;
        border-bottom: 0 !important;

        .TableContainer {
            border-radius: 0 !important;
            border: none !important;
        }
        .TableHead {
            box-shadow: none !important;
            border-radius: 0 !important;
        }
        .TableBody {
            .TableBodyRow {
                height: 5.375rem;
            }
        }
    `,
) as typeof Table;
